import {GoalStatusesE} from '@/features/goal/types'
import {StyledExplanationRoot} from './style'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {calculatePercentage} from '@/utilities/helpers'
import {MIN_SUCCESS_PERCENTAGE} from '@/features/goal/constant/goal'
import {GoalV3} from '@/features/chat/chat.model'

export const HostStatusExplanationSection = ({goal}: {goal?: GoalV3}) => {
    const {t} = useTranslation()
    const percentage = goal && calculatePercentage(goal?.donationsCount, goal?.targetAmount)

    const text = useMemo(() => {
        switch (goal?.status) {
            case GoalStatusesE.ACTIVE:
                if (percentage && percentage >= MIN_SUCCESS_PERCENTAGE) {
                    // active and ready to withdraw
                    return t('goal_page:notification:goal_achived_time_not_ended', {PERCENTAGE: Math.round(percentage)})
                } else {
                    // active
                    return t('goal_page:notification:goal_not_achieved_time_not_ended')
                }
            case GoalStatusesE.AWAITING_PROOF:
            case GoalStatusesE.PROOF_PENDING_APPROVAL:
                return t('goal_page:notification:goal_achieved_or_widthdraw')
            case GoalStatusesE.SUCCESSFUL:
                return t('goal_page:notification:goal_achieved_time_ended')
            case GoalStatusesE.CANCELED:
                return
            default:
                // status: pending, suspended, review
                return t('goal_page:notification:goal_not_achieved_time_not_ended')
        }
    }, [goal?.status, percentage])

    return <StyledExplanationRoot>{text}</StyledExplanationRoot>
}
